import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { searchStaffFn } from 'api/org/per';
import { getShortCode, getCompanyInfo } from 'api/common';
import { transfer as _transfer } from 'api/settings';
import { getUserInfo } from 'api/login';
import s from 'storejs';
export default {
  data: function data() {
    return {
      value: '',
      visible: false,
      loading: true,
      gridData: [],
      options: [],
      mobile: 0,
      input2: '',
      // 员工列表
      staffList: [],
      // 当前选择员工
      staff: '',
      // 验证码text
      qrcodeText: this.$t('822'),
      disabled: false
    };
  },
  methods: {
    init: function init(s, p) {
      this.visible = s;
      this.mobile = p;
    },
    supRemoteMethod: function supRemoteMethod(query) {
      var _this = this;
      if (query !== '') {
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          searchStaffFn({
            search_name: query,
            page_size: 20
          }).then(function (res) {
            if (res && res.code === 1) {
              _this.staffList = res.data.map(function (v) {
                return {
                  staff_name: v.staff_name,
                  staff_id: v.staff_id,
                  mobile: v.mobile
                };
              });
            }
          });
        }, 300);
      } else {
        this.staffList = [];
      }
    },
    // 获取验证码
    gandleGetShortCode: function gandleGetShortCode() {
      var _this2 = this;
      if (this.staff.staff_id && this.mobile) {
        var msg = {
          calling_code: s.get('userInfo').cc,
          mobile: this.mobile
        };
        getShortCode(msg).then(function (res) {
          _this2.$s.set('timer', new Date().getTime());
          _this2.qrcodeTime();
        });
      } else {
        this.$notify({
          title: this.$t('229'),
          message: this.$t('823'),
          type: 'warning'
        });
      }
    },
    // 倒计时
    qrcodeTime: function qrcodeTime() {
      var _this3 = this;
      // const self = this;
      var play = setInterval(function () {
        var current = new Date().getTime();
        var last = _this3.$s.get('timer');
        var haveTime = 60 - (current - last) / 1000;
        if (haveTime > 0) {
          _this3.qrcodeText = "".concat(Math.floor(haveTime), "s");
          _this3.disabled = true;
          return false;
        }
        clearInterval(play);
        _this3.disabled = false;
        _this3.qrcodeText = _this3.$t('822');
      }, 1000);
    },
    // 更换请求
    transfer: function transfer() {
      var _this4 = this;
      _transfer(this.staff).then(function (res) {
        _this4.visible = false;
        getCompanyInfo().then(function (res) {
          s.set('currentCompany', res.data);
          _this4.$parent.currentCompany = _this4.$s.get('currentCompany');
        });
        // 获取用户信息
        getUserInfo().then(function (res) {
          s.set('userInfo', res.data.user_info);
        });
      });
    }
  }
};